import { CSS } from '@grupoboticario/flora-react'

export const balanceRowCss: CSS = {
  alignItems: 'stretch',
  width: '100%'
}

export const balancePanelCss: CSS = {
  flex: '3 1 460px',
  minWidth: '460px'
}

export const brandCardCss: CSS = {
  alignItems: 'flex-start',
  backgroundColor: '$backgroundSecondary',
  borderRadius: '$medium',
  flex: '1 1 160px',
  justifyContent: 'center',
  minHeight: '114px',
  minWidth: '160px',
  padding: '$4'
}

export const brandTitleCss: CSS = {
  color: '$statusSuccessNonInteractivePredominant',
  lineHeight: '$bodySmall',
  whiteSpace: 'nowrap'
}

export const brandPointsCss: CSS = {
  color: '$linkDefault',
  whiteSpace: 'nowrap'
}

export const brandValueCss: CSS = {
  whiteSpace: 'nowrap'
}
